class OwRecentlyViewed extends HTMLElement {
  async connectedCallback() {
    const ids = this.#getProductIds();
    if (ids.length === 0) return;

    try {
      const url = new URL(this.dataset.searchUrl || '/search', window.location.origin);
      url.searchParams.set('section_id', 'ow-recently-viewed');
      url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'none');

      const response = await fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      });
      if (!response.ok) return;

      const markup = await response.text();
      const source = new DOMParser()
        .parseFromString(markup, 'text/html')
        .querySelector('[data-ow-recently-viewed-results]');
      if (!source?.childElementCount) return;

      this.replaceChildren(...Array.from(source.children).map((child) => document.importNode(child, true)));
      this.hidden = false;
    } catch (_error) {
      // Browsing history is an enhancement; it must never interrupt shopping.
    }
  }

  #getProductIds() {
    let ids = [];
    try {
      const stored = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
      if (Array.isArray(stored)) ids = stored;
    } catch (_error) {
      return [];
    }

    const currentProductId = String(this.dataset.currentProductId || '');
    return [...new Set(ids.map(String))]
      .filter((id) => /^\d+$/.test(id) && id !== currentProductId)
      .slice(0, 4);
  }
}

if (!customElements.get('ow-recently-viewed')) {
  customElements.define('ow-recently-viewed', OwRecentlyViewed);
}
